import { Link } from 'react-router-dom';
import { featuredArticles, Article } from '@/mocks/movieData';

function FeaturedCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
    >
      <div className="relative overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full aspect-video object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {article.badge && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            {article.badge}
          </span>
        )}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded text-accent-400 text-xs font-semibold">
          <i className="ri-star-fill text-xs"></i>
          {article.rating}
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {article.description}
        </p>
        <div className="flex items-center gap-2 mt-3 flex-wrap">
          <span className="text-xs text-foreground-400">{article.category}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{article.views} 次浏览</span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">编辑精选，不容错过的好内容</p>
          </div>
          <Link to="/category/dianshiju" className="hidden md:flex items-center gap-1 text-primary-500 text-sm font-medium cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <FeaturedCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}